import "./price_list_injections.scss";
export default function PriceList() {
  return (
    <div className="PriceList">
      <table className="table_1" border="1px" cellSpacing="0px">
        <caption className="detail">
          Price list injections
          <br />
        </caption>
        <tbody>
          <tr>
            <td>Inj. Follisurge 300U pen</td>
            <td>75</td>
            <td>2310</td>
          </tr>
          <tr>
            <td />
            <td>150</td>
            <td>4620</td>
          </tr>
          <tr>
            <td />
            <td>225</td>
            <td>6930</td>
          </tr>
          <tr>
            <td />
            <td>300</td>
            <td>9240</td>
          </tr>
          <tr>
            <td />
            <td>375</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>450</td>
            <td />
          </tr>
          <tr>
            <td>Inj. Pergoveris</td>
            <td>75</td>
            <td>2092</td>
          </tr>
          <tr>
            <td />
            <td>150</td>
            <td>4185</td>
          </tr>
          <tr>
            <td />
            <td>225</td>
            <td>6277</td>
          </tr>
          <tr>
            <td />
            <td>300</td>
            <td>8370</td>
          </tr>
          <tr>
            <td />
            <td>375</td>
            <td>10462</td>
          </tr>
          <tr>
            <td />
            <td>450</td>
            <td>12555</td>
          </tr>
          <tr>
            <td>Inj. Gonal F</td>
            <td>75</td>
            <td>2105</td>
          </tr>
          <tr>
            <td />
            <td>150</td>
            <td>4210</td>
          </tr>
          <tr>
            <td />
            <td>225</td>
            <td>6316</td>
          </tr>
          <tr>
            <td />
            <td>300</td>
            <td>8421</td>
          </tr>
          <tr>
            <td />
            <td>375</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>450</td>
            <td />
          </tr>
          <tr>
            <td>Inj. Puregraf</td>
            <td>75</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>150</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>225</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>300</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>375</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>450</td>
            <td />
          </tr>
          <tr>
            <td>Inj. Ovutas HP</td>
            <td>75</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>150</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>225</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>300</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>375</td>
            <td />
          </tr>
          <tr>
            <td />
            <td>450</td>
            <td />
          </tr>
          <tr>
            <td />
            <td />
            <td />
          </tr>
        </tbody>
      </table>
    </div>
  );
}
